import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46b986da"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dialog"
}

import "@/font/css/font.css";
import { useRouter } from 'vue-router'
import { ref, toRefs } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'myDialog',
  props: {
    dialogVisible: {
        type: Boolean,
        default: 'false'
    },
},
  emits: ['closeDialog'],
  setup(__props, { emit }) {

const props = __props;




const { dialogVisible } = toRefs(props)
const closeDialog = () => {
    emit('closeDialog')
}


return (_ctx: any,_cache: any) => {
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_unref(dialogVisible))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "closeButton",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDialog()))
        }, [
          _createVNode(_component_el_icon, { style: {"color":"#01C2FF","position":"absolute","left":"15px","top":"3px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ]),
        _renderSlot(_ctx.$slots, "content")
      ]))
    : _createCommentVNode("", true)
}
}

})